module.exports = __webpack_public_path__ + "img/header-diamondJewelrySets.8ab056d.webp";